// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"118": "lib-router","72": "lib-axios",}[chunkId] || chunkId) + "." + {"118": "069d409e","232": "94d349fc","354": "d8012716","366": "c7d8f862","72": "ca34d5ce","802": "954aa3a8",}[chunkId] + ".js"
}